import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { makeApiMessage as MakeApiMessage } from '../../../components/src/common'
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import { saudiTimeView } from "./utils";
export interface ITimeSlot {
  id: number;
  end_time: Date;
  start_time: Date;
  promo_code_id: number;
  endDate: Date | string | null | undefined | never;
  startDate: Date | string | null | undefined | never;
}
interface IOption {
  id: number;
  name: string;
  area_name: string;
  store_name: string;
  branch_name: string;
}

export interface IService {
  id: number;
  name: string;
  icon_id: number;
  active: boolean;
  created_at: Date;
  updated_at: Date;
  short_name: string;
  second_name: string;
  order_number: number;
  online_order: boolean;
}

export interface IData {
  id: string;
  attributes: {
    used: string;
    status: string;
    discount?: string;
    name: string;
    description: string;
    discount_type: string;
    areas: Array<string | never>;
    stores: Array<string | never>;
    regions: Array<string | never>;
    sections: Array<string | never>;
    services: Array<string | never>;
    products: Array<string | never>;
    exclude_days: {id:number,day:string}[];
    no_of_orders: number | string | null;
    end_date: string | Date | null | never;
    start_date: string | Date | null | never;
    available_times: Array<ITimeSlot | never>;
    order_types: Array<string | never>;
  };
}
interface Props {
  navigation: {
    navigate: Function;
    getParam: Function;
  };
}
interface State {
  noData: boolean;
  isLoading: boolean;
  isViewLoading: boolean;
  data: IData | never;
  permissionStatus: PermissionStatus;
  isLoadingPermission: boolean;
}
interface SS {}
// Customizable Area Start
export const configJSON = require("./config");
const ApiUrls = configJSON.ApiUrls;
// Customizable Area End

class StoreDiscountViewController extends BlockComponent<Props, State, SS> {
  constructor(props: Props) {
    super(props);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.LayoutDataMessage),
    ];
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  storeDiscountShowMessageId: string = "";

  state: State = {
    // Customizable Area Start
    noData: false,
    isLoading: true,
    isViewLoading: false,
    data: {
      id: "",
      attributes: {
        discount_type: "",
        discount: "",
        description: "",
        status: "",
        name: "",
        used: "",
        no_of_orders: null,
        start_date: "",
        end_date: "",
        available_times: [],
        sections: [],
        services: [],
        products: [],
        exclude_days: [],
        regions: [],
        areas: [],
        stores: [],
        order_types: [],
      },
    },
    permissionStatus: {
      mainPermission: false,
      createPermission: false,
      viewPermission: false,
      editPermission: false,
      deactivatePermission: false
    },
    isLoadingPermission: true
    // Customizable Area End
  };

  receive(from: string, message: Message): void {
    // Customizable Area Start
    this.receiveDataFromLayout(message);
    let requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    let successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (successResponse?.data) {
      if (requestId === this.storeDiscountShowMessageId) {
        let data = successResponse.data;

        data.attributes.sections = data.attributes.sections.map(
          (item: IOption) => item.name
        );
        data.attributes.services = data.attributes.services.map(
          (item: IOption) => item.name
        );
        data.attributes.products = data.attributes.products.map(
          (item: IOption) => item.name
        );
        data.attributes.stores = data.attributes.stores.map(
          (item: IOption) => item.store_name
        );
        data.attributes.areas = data.attributes.areas.map(
          (item: IOption) => item.area_name
        );
        data.attributes.regions = data.attributes.regions.map(
          (item: IOption) => item.branch_name
        );
        data.attributes.order_types = data.attributes.order_type !== null ? data.attributes.order_type.map(
          (item: {name : string}) => String(item).split("_").join(" ")
        ) : [];
        data.attributes.available_times = data.attributes.available_times.map(
          ({ start_time, end_time, id }: ITimeSlot) => {
            return {
              id,
              start_time: saudiTimeView(start_time),
              end_time: saudiTimeView(end_time),
            };
          }
        );

        this.setState({isViewLoading:false, isLoading: false, noData: false, data });
      }
    } else if (successResponse?.error) {
      if (requestId === this.storeDiscountShowMessageId) {
        this.setState({isViewLoading:false, isLoading: false, noData: true });
      }
    }

    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    this.getStoreDiscountItemApi();
  }

  // Customizable Area Start

  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.LayoutMessageData)
        );
        if (recievedData.userContext) {
            this.handleUserChange(recievedData.userContext)
        }
    }
  }

  getStoreDiscountItemApi() {
    this.setState({isViewLoading:true})
    const id = this.props.navigation.getParam("id");
    const requestMessage = MakeApiMessage({
      url: ApiUrls.storeDiscountShow + id,
      method: "get",
    });

    this.storeDiscountShowMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  redirectTo(page: string, props = {}) {
    this.props.navigation.navigate(page, props);
  }

  handleUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.storeDiscountPermissions;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForNewPermissonStatus(apiKey, userData as Array<PermissionGroupArray>);
    this.setState({
      permissionStatus: value,
      isLoadingPermission: false
    })
  };

}


export default StoreDiscountViewController;
